"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardProductWelcomeOffer = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Sanitizer = require("../../../base-components/Sanitizer/Sanitizer");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var CardProductWelcomeOffer = exports.CardProductWelcomeOffer = function CardProductWelcomeOffer(_ref) {
  var productWelcomeOffer = _ref.productWelcomeOffer,
    styles = _ref.styles;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.productWelcomeOffer
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.productWelcomeOfferHeader
  }, productWelcomeOffer.header), /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.productWelcomeOfferContent
  }, productWelcomeOffer.desc && productWelcomeOffer.desc.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement(_Sanitizer.Sanitizer, {
      safelySetInnerHTML: item.text
    });
  })));
};
CardProductWelcomeOffer.propTypes = {
  productWelcomeOffer: _propTypes["default"].shape({
    header: _propTypes["default"].string,
    desc: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      text: _propTypes["default"].string
    }))
  }),
  styles: _propTypes["default"].objectOf(_propTypes["default"].string)
};
CardProductWelcomeOffer.defaultProps = {
  styles: {},
  productWelcomeOffer: {}
};